import { NavigationNewCreateQuestionSvg } from '@/sub-luca-plugin/compatible-components/svg-icons';
import { tCommon } from '@/sub-luca-plugin/i18n';

interface NewQuestionBtnProps {
    onClick?: () => void;
}

const NewQuestionBtn = ({ onClick }: NewQuestionBtnProps) => {
    return (
        <div className="navigation-bar__create-new-question" onClick={onClick}>
            <NavigationNewCreateQuestionSvg className="navigation-bar__create-new-question-icon" />
            <span>{tCommon.t('newQuestion', '新问题')}</span>
        </div>
    );
};

export default NewQuestionBtn;
